import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { JwtService } from '@modules/auth/services/jwt.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private jwtService: JwtService) {}

  canActivate(): boolean {
    const isValidToken = this.jwtService.isValidToken();
    const isValidRefreshToken = this.jwtService.isValidRefreshToken();
    if (isValidToken || isValidRefreshToken) {
      return true;
    }
    window.location.href = '/auth/login';
    return false;
  }
}